import { Edit } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";

interface Props {
  onClick?: () => void;
  right?: string;
  top?: string;
  position?: "absolute" | "relative";
  asButton?: boolean;
}

export const EditWorkspaceButton: React.FC<Props> = ({
  onClick,
  position = "absolute",
  right = "10px",
  top = "10px",
  asButton = true,
}) => {
  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>
  ) => {
    if (!onClick) return;
    e.stopPropagation();
    onClick?.();
  };

  const editIcon = (
    <Edit
      sx={{
        fontSize: 14,
        color: "text.secondary",
      }}
    />
  );

  if (!asButton) {
    return (
      <Box
        onClick={handleClick}
        sx={{
          cursor: "pointer",
          padding: "8px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&:hover": {
            backgroundColor: "action.hover",
          },
          position,
          right,
          top,
        }}
      >
        {editIcon}
      </Box>
    );
  }

  return (
    <IconButton
      onClick={handleClick}
      sx={{
        position,
        right,
        top,
      }}
    >
      {editIcon}
    </IconButton>
  );
};
